import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component, input } from '@angular/core'
import {MatIcon} from "@angular/material/icon";
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-password-validation-step',
    templateUrl: './password-validation-step.component.html',
    styleUrls: ['./password-validation-step.component.scss'],
    animations: [
        trigger('iconAnimation', [
            state('close', style({ opacity: 1, transform: 'scale(1)' })),
            state('check', style({ opacity: 1, transform: 'scale(1)' })),
            transition('close <=> check', [
                animate('200ms ease-in-out', style({
                    opacity: 0,
                    transform: 'scale(0.8)',
                })),
                animate('200ms ease-in-out'),
            ]),
        ]),
    ],
    imports: [
        MatIcon,
        NgClass
    ]
})
export class PasswordValidationStepComponent {
	error = input.required<string | null>()

	isDirty = input.required<boolean>()

	validationMessage = input.required<string>()

	constructor() {
	}
}
